import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 50 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M25.251 6.461c-10.318 0-18.683 8.365-18.683 18.683h4.068c0-8.071 6.543-14.615 14.615-14.615z" }, [
      _createElementVNode("animateTransform", {
        attributeName: "transform",
        attributeType: "xml",
        dur: "0.6s",
        from: "0 25 25",
        repeatCount: "indefinite",
        to: "360 25 25",
        type: "rotate"
      })
    ], -1)
  ])))
}
export default { render: render }